import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import getAuthHeader from '@/util/getAuthHeader';

export default {
  async upload(request: RequestUpload): Promise<AxiosResponse<ResponseUpload>> {
    const response: AxiosResponse<ResponseUpload> = await client.post<ResponseUpload>('optional_doc_photos', request, {
      headers: getAuthHeader()
    });
    return response;
  },

  async images(opDocPhotoId: number): Promise<AxiosResponse<ResponseImages>> {
    const response: AxiosResponse<ResponseImages> = await client.get<ResponseImages>(
      `optional_doc_photos/${opDocPhotoId}/images`,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async confirm(opDocPhotoId: number): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `optional_doc_photos/${opDocPhotoId}/update_confirmed_result`,
      {},
      { headers: getAuthHeader() }
    );
    return response;
  }
};

export interface RequestUpload {
  imageBase64: string;
  optionalDocType: string;
  pageNumber: number;
}

export interface ResponseUpload {
  optionalDocPhotoId: number;
}

export interface ResponseImages {
  imageBase64: string;
}
